(function (module) {
    'use strict';

    /**
     * formly type `cssHideSelect` — a material select that hides itself with
     * CSS (the shared `formly-css-hidden` class) instead of angular-formly's
     * default `ng-if` hide. The select twin of `cssHideInput`.
     *
     * Why: angular-formly 8.4.1's ng-if hide is unsafe for fields that toggle
     * visibility, twice over:
     *  - re-render desync — a field hidden by `hideExpression` at first render
     *    is removed from the DOM and NOT re-inserted when the condition later
     *    becomes false (stage 2026-07-22, see formly-css-hide-input.js);
     *  - re-instantiation crash — when a previously-visible field is re-shown,
     *    formly re-runs its api-check against options that now carry
     *    `formControl`, and api-check's unconditional deep arg walk escapes
     *    through `formControl.$$scope` into the scope graph until it reads
     *    `.constructor` on the cross-origin player-preview iframe, throwing a
     *    SecurityError that aborts the digest (stage 2026-08-09, see
     *    formly-disable-api-check.js).
     * The Achievers 1.0.14 schema hit both with `hideExpression` on its
     * longServiceLayout and commentOverflowBehavior selects.
     *
     * This type stays mounted and toggles `formly-css-hidden` from
     * `templateOptions.cssHide`, so it can neither desync nor re-instantiate.
     * Unlike cssHideInput it does NOT clear the model value on hide: keeping
     * the chosen option across visibility flips (e.g. the Long Service layout
     * across feed switches) is desired, and a select cannot hold an invalid
     * value — the options list is the validation. The control is ng-disabled
     * and not ng-required while hidden, so a hidden select can never block
     * Save.
     *
     * The field must NOT set `hideExpression` (that re-introduces the ng-if).
     * Drive visibility with a non-self expression:
     *   expressionProperties: { 'templateOptions.cssHide': "<hide condition>" }
     */
    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'cssHideSelect',
            template:
                '<md-input-container class="md-block" ng-class="{ \'formly-css-hidden\': to.cssHide }">' +
                '<label>{{ to.label }}</label>' +
                '<md-select name="{{ id }}"' +
                ' ng-model="model[options.key]"' +
                ' md-theme="{{ to.theme }}"' +
                ' ng-disabled="to.cssHide || to.disabled"' +
                ' ng-required="!to.cssHide && to.required">' +
                '<md-option ng-repeat="option in to.options" ng-value="option[to.valueProp || \'value\']">' +
                '{{ option[to.labelProp || \'name\'] }}' +
                '</md-option>' +
                '</md-select>' +
                '<div ng-messages="fc.$error" role="alert" ng-if="!to.cssHide">' +
                '<div ng-message="required">This field is required.</div>' +
                '</div>' +
                '</md-input-container>',
        });
    }]);
})(angular.module('rocket.components'));
